export const nonOwnedOptions = [
  { value: 0, label: "None" },
  { value: 250000, label: "$250,000" },
  { value: 500000, label: "$500,000" },
];
